<template>
  <div
    v-if="pendingInvitations.length"
    class="mt-8 mb-12 bg-grey-darker pt-4 pb-8"
  >
    <h3
      class="text-white"
      v-text="heading"
    />
    <section class="flex flex-wrap items-stretch justify-center ">
      <article
        v-for="invitation in pendingInvitations"
        :key="invitation.uuid"
        class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card"
      >
        <div class="card card-bio-content text-center bg-white">
          <h6
            class="text-blue uppercase -mt-2 mb-4"
            v-text="`${invitation.membership.union.level_name} Organization`"
          />
          <img
            class="rounded-full"
            style="width: 80%; max-width: 150px;"
            :src="invitation.membership.union.logo"
          >
          <h4
            class="px-2 text-blue font-bold tracking-normal"
            v-text="invitation.membership.union.name"
          />
          <AcceptRejectButtons :invitation-code="invitation.code" />
        </div>
      </article>
    </section>
  </div>
</template>

<script type="text/babel">
import AcceptRejectButtons from './AcceptRejectButtons'

export default {
  name: 'PendingInvitations',
  components: {
    AcceptRejectButtons,
  },
  props: {
    pendingInvitations: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    heading() {
      return this.pendingInvitations.length === 1
        ? 'You have a pending invitation!'
        : `You have ${this.pendingInvitations.length} invitations!`
    },
  },
}
</script>
